var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flight-card bg-white py-1 px-0.5 rounded-md border border-grayNeutralLight w-[260px] flex-shrink-0"},[_c('div',{staticClass:"w-full flex justify-between items-center mb-1"},[_vm._t("header")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }